import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import "./chosenSuitComp.scss";
function ChosenSuitComp() {
  const show = useSelector((state) => state.suit.showChosenSuit);
  // const chosenSuit = useSelector((state) => state.suit.chosenSuit);
  const backgroundPos = useSelector((state) => state.suit.bgposition);

  useEffect(() => {
    console.log("rerunning");
  }, [backgroundPos]);
  return show ? (
    <div className="chosensuit">
      {/* pass values to backPostion to show the suit needed 
      possible values : 0% | 33.33% | 66.66% | 99.99% */}

      <span
        style={{
          backgroundPosition: `${backgroundPos}% 0px`,
          // display: chosenSuit ? 'block' : 'none',
        }}
      ></span>
    </div>
  ) : null;
}

export default ChosenSuitComp;
